export const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Downloads a wire import CSV file by its S3 key.
 * Returns a tuple of [blob, filename] for the caller to handle,
 * or throws on failure.
 */
export const downloadWireImportCSV = async (
  s3Key: string,
  originalFilename: string,
): Promise<void> => {
  const encodedKey = s3Key.split("/").map(encodeURIComponent).join("/");
  const response = await fetch(`/v1/wire_import/csv/download/${encodedKey}`, {
    method: "GET",
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }
  const blob = await response.blob();
  triggerBlobDownload(blob, originalFilename);
};